export const trackHeap = (event_name, payload) => {
  if (window.heap) {
    window.heap.track(event_name, payload);
  }
};
